{
    "coordinates": [
        48.898945036161024,
        11.002373806097921
    ],
    "tooltip": "Solnhofen",
    "title": "Altmühltal Formation (Solnhofen Limestone)",
    "country": "Germany",
    "period": "Jurassic",
    "alt": "TODO"
}
